import { Component } from '@angular/core';
import { CommonHelper } from './helpers/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'LMPLIVE.TV';
  public get isNoHeaderFooter(): boolean {
    var noHeaderPaths = ['playerapp', 'getApp'];
    var ff = false;
    for(var h in noHeaderPaths){
        if(noHeaderPaths[h] == this.commonHelper.currentUrl){
          ff = true;
          break;
        }
    }
    return ff;
  } 
  public get isNoHeader(): boolean {
    var noHeaderPaths = ['player'];
    var ff = false;
    for(var h in noHeaderPaths){
        if(noHeaderPaths[h] == this.commonHelper.currentUrl){
          ff = true;
          break;
        }
    }
    return this.isNoHeaderFooter ? true : ff;
  } 

  public get isNoHeaderD(): boolean {
    var noHeaderPaths = ['getApp'];
    var ff = false;
    for(var h in noHeaderPaths){
        if(noHeaderPaths[h] == this.commonHelper.currentUrl){
          ff = true;
          break;
        }
    }
    return ff;
  } 

  constructor(private commonHelper: CommonHelper) {
  }
}
